@if (!!images?.length) {
  <div
    class="relative max-h-full max-w-full h-full w-full"
    data-ride="carousel"
    >
    <!--
      a11y: top close (X) button. FIRST in DOM so CDK FocusTrap.focusInitial-
      ElementWhenReady() (driven by [focusInitial]=true) lands focus here on
      open. Visually positioned in the top-trailing corner via absolute
      positioning to overlay the photo.
    -->
    <mot-button
      matType="icon"
      icon="close"
      class="!absolute top-2 right-2 z-10"
      [style]="{
        background: 'rgba(0, 0, 0, 0.6)'
      }"
      iconClass="text-white"
      [ariaLabel]="closeText"
      [focusInitial]="true"
      (onClick)="close()"
      />

    <img
      [src]="getSlide()"
      class="h-full w-full"
      style="max-height: 100vh; max-width: 100vw"
      [alt]="getSlideAlt()"
      />
      <mot-button
        matType="icon"
        icon="chevron-left"
        class="absolute left-4 top-1/2"
    [style]="{
      background: 'rgba(0, 0, 0, 0.6)'
    }"
        iconClass="text-white"
        [ariaLabel]="previousImageText"
        (onClick)="getPrev()"
        />
        <mot-button
          matType="icon"
          icon="chevron-right"
          class="absolute right-4 top-1/2"
    [style]="{
      background: 'rgba(0, 0, 0, 0.6)'
    }"
          iconClass="text-white"
          [ariaLabel]="nextImageText"
          (onClick)="getNext()"
          />
        </div>
      }
